<div *ngIf="message && message.type !== '' && message.text !== ''" [class]="'alert_message ' + (message ? message.type : '')">{{ message.text }}</div>